import { useEffect, useState } from 'react'
import { trackError } from '@vend/utilities'
import { ApiReceiptSettings } from '@vend/types'
import {
  useReceiptSettingsStore,
  useRegisterManager,
} from '../../../ng-compat/hooks'

export const useReceipts = () => {
  const receiptSettingsStore = useReceiptSettingsStore()
  const registerManager = useRegisterManager()
  const [otherReceipts, setOtherReceipts] = useState<ApiReceiptSettings[]>([])
  const [
    defaultReceipt,
    setDefaultReceipt,
  ] = useState<ApiReceiptSettings | null>(null)

  useEffect(() => {
    receiptSettingsStore
      .all()
      .then(settings => {
        const defaultReceiptId = registerManager.getActiveRegister()
          .receipt_template_id

        const filteredReceipts: ApiReceiptSettings[] = []
        settings.forEach(receipt => {
          if (receipt.id === defaultReceiptId) {
            setDefaultReceipt(receipt)
          } else {
            filteredReceipts.push(receipt)
          }
        })

        setOtherReceipts(filteredReceipts)
      })
      .catch(err => {
        trackError('[useReceipts] Failed to load receipt settings', err)
      })
  }, [receiptSettingsStore, registerManager])

  return { defaultReceipt, otherReceipts }
}
